<template>
  <SportFeaturePlaceholder
    sport-label="Tennis"
    title="Register Tennis Team"
    description="Tennis registration route is now active in Match Hub. Next step is wiring full tennis backend registration endpoints."
    primary-cta="Go to Match Hub"
    :primary-route="{ name: 'MatchesHub' }"
    :back-route="{ name: 'MatchesHub' }"
  />
</template>

<script>
import SportFeaturePlaceholder from "@/routes/match_hub/shared/SportFeaturePlaceholder.vue";
export default { name: "TennisTeamRegistration", components: { SportFeaturePlaceholder } };
</script>
